export enum SizeType {
  catalog = 1,
  custom = 2,
}

export enum CustomSizeType {
  innerDimensions = 1,
  outerDimensions = 2,
}
